import { observable } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment';

export type OpenMeetingSlotResponseArgs = {
  id: number;
  appoint_open_meeting_id: number;
  start_time: string;
  end_time: string;
};

export type OpenMeetingSlotArgs = {
  id?: number;
  openMeetingId?: number;
  startTime: Moment;
  endTime: Moment;
};

export const convertOpenMeetingSlotResponseToArgs = (response: OpenMeetingSlotResponseArgs) => {
  const args: OpenMeetingSlotArgs = {
    id: response.id,
    openMeetingId: response.appoint_open_meeting_id,
    startTime: moment(response.start_time),
    endTime: moment(response.end_time)
  };
  return args;
};

export const defaultOpenMeetingSlotArgs = (openMeetingId: number | undefined, day: number) => {
  const startTime = moment().startOf('week').add('days', day).set('hour', 9).set('minute', 0);
  return {
    openMeetingId,
    startTime,
    endTime: startTime.clone().set('hour', 18).set('minute', 0)
  };
};

export default class OpenMeetingSlot {
  @observable id?: number;
  @observable openMeetingId?: number;
  @observable startTime: Moment;
  @observable endTime: Moment;

  constructor(args: OpenMeetingSlotArgs) {
    this.id = args.id;
    this.openMeetingId = args.openMeetingId;
    this.startTime = args.startTime;
    this.endTime = args.endTime;
  }

  setTime(type: 'start' | 'end', time: string) {
    const [hour, minute] = time.split(':').map(str => parseInt(str, 10));
    if (type === 'start') {
      this.startTime.set('hour', hour).set('minute', minute);
      if (this.startTime.unix() > this.endTime.unix()) {
        this.endTime = this.startTime.clone().add('hour', 1);
      }
    } else {
      this.endTime.set('hour', hour).set('minute', minute);
      if (this.startTime.unix() > this.endTime.unix()) {
        this.startTime = this.endTime.clone().subtract('hour', 1);
      }
    }
  }

  submitParams() {
    return {
      id: this.id,
      appoint_open_meeting_id: this.openMeetingId,
      start_time: this.startTime.format(),
      end_time: this.endTime.format()
    };
  }
}
